import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function MaskedLine({ children, delay = 0, className = "", onLoad = false, as: Tag = "span" }) {
  const anim = onLoad
    ? { initial: { y: "115%" }, animate: { y: 0 } }
    : { initial: { y: "115%" }, whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } };
  return (
    <Tag className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        {...anim}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <p className={`text-[11px] uppercase tracking-[0.35em] font-medium ${dark ? "text-[#8EA696]" : "text-[#1B3B28]"}`}>
      {children}
    </p>
  );
}
